<template>
  <h2
    class="truncate text-left text-xl font-semibold text-headline"
    :class="marginClass"
  >
    <slot></slot>
  </h2>
</template>

<script setup lang="ts">
import { computed, useAttrs } from "vue";

const attrs = useAttrs();
const marginClass = computed(() => {
  return (attrs as { class: string })?.class?.includes("mb-") ? "" : "mb-8";
});
</script>
